import { useParams } from "react-router-dom";
import CoursePlansSelection from "@/components/student/CoursePlansSelection";

type Props = {
  params?: Promise<{ id: string }>;
};

export default function CoursePlansPage(props?: Props) {
  const routerParams = useParams<{ id: string }>();
  const courseUuid = routerParams.id || "";

  return (
    <div className="min-h-screen bg-gray-50/80">
      <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 sm:py-14 lg:px-8">
        <CoursePlansSelection courseUuid={courseUuid} />
      </div>
    </div>
  );
}
